/**
 * 言語設定の getters
 */
const getters = {
};

export { getters as default };
